// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

export default function DocLinkDialog(props) {

  const open = props.open || false
  const docLink = props.docLink || ""
  const onClose = props.onClose

  const linkRef = React.useRef(null);

  const handleCloseClick = () => {
    onClose && onClose();
  }

  async function copyTextToClipboard(aText) {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(aText);
    } else {
      return document.execCommand('copy', true, aText);
    }
  }


  const [openSuccessToast, setOpenSuccessToast] = useState(false);
  const handleSuccessToastClose = () => {
    setOpenSuccessToast(false);
  }
  const [openFailToast, setOpenFailToast] = useState(false);
  const handleFailToastClose = () => {
    setOpenFailToast(false);
  }

  const handleCopyClick = () => {
    copyTextToClipboard(docLink)
      .then(() => {
        setOpenSuccessToast(true);
      })
      .catch((err) => {
        console.log(err);
        setOpenFailToast(true);
      });
  }

  return (
    <Dialog
      open={open}
      onClose={handleCloseClick}
      fullWidth={true}
      // minWidth={"lg"}
      aria-describedby="docLink-dialog-description"
    >
      <DialogTitle id="docLink-dialog-title">
        Document Link
      </DialogTitle>
      <DialogContent>
        <Snackbar
          open={openSuccessToast}
          autoHideDuration={2000}
          onClose={handleSuccessToastClose}
        >
          <Alert elevation={6} variant="filled" severity="success" sx={{ width: '100%' }}>
            Copied!
          </Alert>
        </Snackbar>

        <Snackbar
          open={openFailToast}
          autoHideDuration={2000}
          onClose={handleFailToastClose}
        >
          <Alert elevation={6} variant="filled" severity="error" sx={{ width: '100%' }}>
            Fail to copy into clipboard!
          </Alert>
        </Snackbar>

        <Box component="div" sx={{ display: 'flex', alignItems: 'center', }} >
          <TextField
            id="filled-basic"
            ref={linkRef}
            hiddenLabel
            size="small"
            value={docLink}
            fullWidth
            InputProps={{ readOnly: true, }}
            // variant="filled"
          />
          <Button onClick={() => handleCopyClick()}>
            Copy
          </Button>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseClick}>Close</Button>
      </DialogActions>
    </Dialog>

  );
}

DocLinkDialog.propTypes = {
  open: PropTypes.bool,
  docLink: PropTypes.string,
  onClose: PropTypes.func,
};
